/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontHome_user = {
    readonly " $fragmentRefs": FragmentRefs<"StorefrontFeaturedSection_user">;
    readonly " $refType": "StorefrontHome_user";
};
export type StorefrontHome_user$data = StorefrontHome_user;
export type StorefrontHome_user$key = {
    readonly " $data"?: StorefrontHome_user$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontHome_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "StorefrontHome_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "StorefrontFeaturedSection_user",
      "args": null
    }
  ]
};
(node as any).hash = 'c8f3973dfb191c16a7a06932ffba73d2';
export default node;
